import React from "react";

function Comet(){
    return (
        <picture>
  <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/2604_fe0f/512.webp" type="image/webp"/>
  <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/2604_fe0f/512.gif" alt="☄" width="420" height="420" z-index="-1"/>
        </picture>
    )
}

export default Comet